import { IonModal } from '@ionic/react';
import FlowModalHeader from './FlowModalHeader';
import NoPwProfile1 from './ModalPages/NoPwProfile1';
import '../../theme/FlowModal.css';

/** The notification sign-up page for passwordless users: one step, no close. */
function NoPwRegisterModal() {
    return (
        <IonModal className='flow-modal' isOpen={true} backdropDismiss={false}>
            <FlowModalHeader title='Sign Up For Notifications' step={0} totalSteps={0} />
            <NoPwProfile1 />
        </IonModal>
    );
}

export default NoPwRegisterModal;
